import React from "react";
import { MDBRow, MDBCol, MDBContainer } from "mdbreact";

import LinkReadToo from "../../../template/LinkReadToo";
import ShareBtns from "../../../template/ShareBtns";

import bannerImg from "../../../../assets/img/deficiencia-visual/banner.jpg";

import Banner from "../../../template/Banner";

export default () => {
  const description =
    "Lorem ipsum dolor sit, amet consectetur adipisicing elit.";
  return (
    <div className="deficiencia-visual">
      <Banner
        title="DEFICIÊNCIA VISUAL"
        subtitle={description}
        img={bannerImg}
      />

      <MDBContainer className="mt-4">
        <ShareBtns
          title={document.title}
          description={description}
          image={bannerImg}
        />
      </MDBContainer>

      <div className="content container d-flex justify-content-center align-items-center flex-column">
        <MDBRow>
          <MDBCol md="8" sm="12">
            <h1>LOREM IPSUM</h1>
            <p>
              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Cumque
              natus accusantium qui labore molestias. Consequuntur totam eaque
              vero suscipit fuga reprehenderit sit quia aspernatur, neque iusto
              optio, ab sed possimus? Lorem ipsum dolor sit amet consectetur
              adipisicing elit. Autem libero commodi molestiae voluptate quas
              laborum ipsa rem magni? Eveniet accusamus fugit dicta porro omnis
              beatae impedit aspernatur quasi nihil minus.
            </p>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Reiciendis adipisci molestias ipsam. Adipisci quasi est unde culpa
              eos quas rerum maiores atque architecto laborum libero quam,
              voluptatum aliquam, harum voluptatibus! Lorem ipsum dolor sit
              amet, consectetur adipisicing elit. Dolore, enim voluptatibus
              tenetur corporis sed fugit consequuntur voluptatum veritatis
              officia beatae suscipit quis adipisci, sint expedita odio soluta
              et. Eius, provident!
            </p>
          </MDBCol>
          <MDBCol md="4" sm="12">
            <h1>LEIA TAMBÉM</h1>
            <LinkReadToo
              path="/fundacao/deficiencia-visual/dicas-de-como-conviver-com-o-deficiente-visual"
              title="Dicas de como conviver com o deficiente visual"
            />
          </MDBCol>
        </MDBRow>
      </div>
    </div>
  );
};
